export default __webpack_public_path__ + "static/media/RhymesAnimalTales_12.1533409a.png";